import React, { PureComponent } from 'react';
import { Card, Icon, Popup } from 'semantic-ui-react';

export default class ChartCard extends PureComponent {
  render() {
    const {
      children, title, className, description, subtitle
    } = this.props;
    return (
      <Card className={`chart-card ${className}`}>
        <div className="title" style={{ textAlign: 'center' }}>
          <span>{title}</span>
        </div>
        {
          subtitle ? (
            <span style={{ textAlign: 'center', color: '#999' }}>{subtitle}</span>
          ) : null
        }
        <Popup
          content={description}
          key={title}
          trigger={<Icon className="infoIcon" style={{ position: 'absolute', right: 15, top: 15 }} as="i" name="info circle" />}
          basic
          wide="very"
          position="bottom center"
        />
        {children}
      </Card>
    );
  }
}
